import { render, staticRenderFns } from "./RatingsCard.vue?vue&type=template&id=629ab8b8&"
import script from "./RatingsCard.vue?vue&type=script&lang=ts&"
export * from "./RatingsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports